import { api } from './client.ts';
import type { VisitPricing, VisitPricingUpdate } from '@shared/visit-pricing.ts';

export const visitPricingApi = {
  get: (id: string, signal?: AbortSignal) => api.getFresh<VisitPricing>(`/visit-pricing/${id}`, signal),
  update: (id: string, input: VisitPricingUpdate) => api.put<VisitPricing>(`/visit-pricing/${id}`, input),
};
